import { Routes, Route, Link, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import Layout from '@/components/Layout'
import AuthLayout from '@/components/AuthLayout'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Academics from '@/pages/Academics'
import Admission from '@/pages/Admission'
import Contact from '@/pages/Contact'
import Gallery from '@/pages/Gallery'
import StudentRegister from '@/pages/StudentRegister'
import StaffLogin from '@/pages/StaffLogin'
import StudentLogin from '@/pages/StudentLogin'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import StaffLayout from '@/components/StaffLayout'
import StaffDashboardHome from '@/pages/StaffDashboardHome'
import StaffProfile from '@/pages/StaffProfile'
import StaffStudents from '@/pages/StaffStudents'
import StaffResults from '@/pages/StaffResults'
import StaffAttendance from '@/pages/StaffAttendance'
import StaffSubjects from '@/pages/StaffSubjects'
import StaffNotifications from '@/pages/StaffNotifications'
import StudentLayout from '@/components/StudentLayout'
import StudentDashboardHome from '@/pages/StudentDashboardHome'
import StudentProfile from '@/pages/StudentProfile'
import StudentEditProfile from '@/pages/StudentEditProfile'
import StudentResults from '@/pages/StudentResults'
import StudentPayments from '@/pages/StudentPayments'
import StudentSubjects from '@/pages/StudentSubjects'
import StudentNotifications from '@/pages/StudentNotifications'
import StudentEdit from '@/pages/StudentEdit'

const PlaceholderPage = ({ title }) => (
  <div className="container py-20 text-center">
    <h1 className="text-4xl font-bold text-slate-800 mb-4">{title}</h1>
    <p className="text-slate-500">Feature coming soon</p>
    <Link to="/" className="text-primary hover:underline mt-4 inline-block">← Back to Home</Link>
  </div>
);

const NotFoundPage = () => (
  <div className="container py-20 text-center">
    <h1 className="text-6xl font-black text-slate-200 mb-4">404</h1>
    <h2 className="text-2xl font-bold text-slate-800 mb-4">Page Not Found</h2>
    <p className="text-slate-500 mb-8">The page you are looking for does not exist.</p>
    <Link to="/" className="bg-gradient-to-r from-primary to-primary-600 text-white px-8 py-3 rounded-xl font-bold shadow-lg hover:shadow-xl transition-all inline-flex items-center gap-2">
      <i className="fas fa-home"></i> Back to Home
    </Link>
  </div>
);

function App() {
  return (
    <AuthProvider>
    <Routes>
      {/* Public Pages with Layout */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/academics" element={<Academics />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
      </Route>

      {/* Auth Pages - with AuthLayout (header only, no footer) */}
      <Route element={<AuthLayout />}>
        <Route path="/auth/student-register" element={<StudentRegister />} />
        <Route path="/auth/staff-login" element={<StaffLogin />} />
        <Route path="/auth/student-login" element={<StudentLogin />} /> 
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />
        <Route path="/student/login" element={<StudentLogin />} />
      </Route>

      {/* Student Dashboard with Layout */}
      <Route path="/student" element={<StudentLayout />}>
        <Route index element={<Navigate to="/student/dashboard" replace />} />
        <Route path="dashboard" element={<StudentDashboardHome />} />
        <Route path="profile" element={<StudentProfile />} />
        <Route path="edit-profile" element={<StudentEditProfile />} />
        <Route path="results" element={<StudentResults />} />
        <Route path="payments" element={<StudentPayments />} />
        <Route path="subjects" element={<StudentSubjects />} />
        <Route path="notifications" element={<StudentNotifications />} />
      </Route>

      {/* Admin Login */}
      <Route path="/admin/login" element={<StaffLogin />} />

      {/* Admin Dashboard with Layout */}
      <Route path="/admin" element={<StaffLayout />}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<StaffDashboardHome />} />
        <Route path="profile" element={<StaffProfile />} />
        <Route path="students" element={<StaffStudents />} />
        <Route path="students/:id/edit" element={<StudentEdit />} />
        <Route path="results" element={<StaffResults />} />
        <Route path="attendance" element={<StaffAttendance />} />
        <Route path="subjects" element={<StaffSubjects />} />
        <Route path="notifications" element={<StaffNotifications />} />
      </Route>

      {/* Placeholder routes for future features */}
      <Route path="/auth/*" element={<PlaceholderPage title="Auth Area" />} />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </AuthProvider>
  )
}

export default App

